import { Navigation } from '../translations-types';

const translations: Navigation = {
  dashboard: 'Dashboard',
  customers: 'Customers',
  employees: 'Employees',
  questionnaires: 'Questionnaires',
  settings: 'Settings',
  import: 'Import customers',
  subscriptions: 'Subscriptions',
  payments: 'Payments',
  messaging: 'Whatsapp credits',
  salons: 'Branches',
  roles: 'Roles',
  customFields: 'Customer labels',
  organisationSettings: 'Organisation settings',
  assistants: 'AI credit',
  assistantsConfig: 'Assistants',
  calendar: 'Calendar',
  salonized: 'Salonized',
  advice: 'Advice',
  adviceConditions: 'Advice module conditions',
  adviceGroups: 'Advice module groups',
  trainings: 'Blueprint',
  userManual: 'User manual',
  courses: 'Academy',
  salesImport: 'Import sales lines',
  nameMatch: 'Clientname matching',
  plans: 'Treatment courses',
  treatmentAnalysis: 'Treatment analysis',
  koppelingen: 'Connections',
  groupGeneral: 'General',
  groupCompany: 'Company',
  groupCustomers: 'Customers',
  groupPlans: 'Treatment courses',
  groupData: 'Data & import',
  spokenAdvice: 'Spoken AI advice',
  sneladvies: 'Especially for you',
  documentsAndConsentForms: 'Documents & Consent forms',
};

export default translations;
